import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import { unmountComponentAtNode } from "react-dom";
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {appDatabasePrimaryFunctions, base} from '../../base';
import {confirmAlert, confirmAlertAsync} from '../utils/react-confirm-alert';
import { validateEmail } from '../utils/HelpfulFunction';
import appBackgroundImage from '../../styles/images/trivia_background.png';
import sampleAppFrontImage from '../../styles/images/front_icon.png';
import sampleAppTopImage from '../../styles/images/top_icon.png';
import AnswerItemsComponent from '../../components/small_components/AnswerItemsComponent';
import { getDistance } from 'geolib';
import posed, {PoseGroup} from "react-pose";
import ReactPlayer from 'react-player';

const Trans = posed.div({
  enter: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: ({ delta }) => - delta * 100 + 'vw' }
})

class Main_App extends Component {
    constructor(props) {
        super(props);
        this.state = {
          userEmail: props.appStorage.getItem('userEmail') || props.appStorage.getItem('tempToken') || false,
          alerted: false,
          answerList: [],
          gameActive: false,
          questionNumber: 0,
          questionAnswered: false,
          userAnswers: [],
          currentGameResponses: [],
          currentGame: {},
          voteSession: false,
          locationChecking: true,
          modalVideo: false,
          videoDuration: "0:00",
          seenVideo: false,
          formQuestions: [],
          otherInput: "",
        };
        this.logout = this.logout.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onEnded = this.onEnded.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    removeReactAlert(){
      document.body.classList.remove('react-confirm-alert-body-element');
      const target = document.getElementById('react-confirm-alert');
      if(target){
        unmountComponentAtNode(target);
        target.parentNode.removeChild(target)
      }
      const svg = document.getElementById('react-confirm-alert-firm-svg');
      if(svg){
        svg.parentNode.removeChild(svg);
        document.body.children[0].classList.remove('react-confirm-alert-blur')
      }
    }

    componentDidMount() {
      const userEmail = this.state.userEmail;
      let base64EncodedEmail = btoa(userEmail);
      if(userEmail && userEmail.indexOf('@') === -1){
        base64EncodedEmail = userEmail
      }

      this.allResponsesRef = base.bindToState('userAnswers', {
        context: this,
        state: 'userAnswers',
        asArray: true,
      });

      this.gameActiveRef = base.bindToState('currentGame/active', {
        context: this,
        state: 'gameActive',
      });

      this.questionAnsweredRef = base.bindToState('currentGame/answered', {
        context: this,
        state: 'questionAnswered',
      });

      this.questionsRef = base.bindToState('currentGame/questions', {
        context: this,
        state: 'questions',
      });

      this.allowMultipleVotesRef = base.bindToState('currentGame/allowMultipleVotes', {
        context: this,
        state: 'allowMultipleVotes'
      });

      this.numberOfVotesRef = base.listenTo('currentGame/numberOfVotes', {
        context: this,
        state: 'numberOfVotes',
        then(numberOfVotes){
          let queries = {orderByChild: 'uid', equalTo: base64EncodedEmail}
          // if(typeof numberOfVotes === "number"){
          //   queries['limitToLast'] = numberOfVotes
          // }
          this.currentGameResponsesRef = base.listenTo('userAnswers', {
            context: this,
            asArray: true,
            queries: queries,
            then(currentGameResponses){
              if(currentGameResponses.length === 0 && this.props.variables && this.props.variables.collectDistance && this.props.variables.formattedAddress && this.props.variables.acceptableDistance){
                this.setState({
                  numberOfVotes: numberOfVotes,
                }, () => {
                  this.checkUsersLocation();
                })
              } else {
                this.setState({
                  numberOfVotes: numberOfVotes,
                  currentGameResponses: currentGameResponses,
                  locationChecking: false,
                  startAnimating: true,
                })
              }
            }
          });
        }
      });

      this.endVideoLinkRef = base.listenTo('currentGame/endPollingVideoLink', {
        context: this,
        then(endPollingVideoLink){
          this.setState({
            endPollingVideoLink: endPollingVideoLink
          })
        }
      });

      this.sessionLengthRef = base.bindToState('currentGame/sessionLength', {
        context: this,
        state: 'sessionLength'
      });

      this.voteSessionRef = base.bindToState('currentGame/voteSession', {
        context: this,
        state: 'voteSession'
      });

      this.formQuestionsRef = base.bindToState("formQuestions", {
        context: this,
        state: 'formQuestions',
        asArray: true
      });

      this.currentGameKeyRef = base.listenTo(`currentGame/id`, {
        context: this,
        then(key){
          if(typeof key === "string") {
            this.logUserActivity(key);
          }
        }
      });
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
      window.scrollTo(0,0)
      this.props.loadPage();
    }

    componentWillUnmount() {
      base.removeBinding(this.currentGameKeyRef);
      base.removeBinding(this.questionsRef);
      base.removeBinding(this.gameActiveRef);
      base.removeBinding(this.allResponsesRef);
      if(this.currentGameResponsesRef){
        base.removeBinding(this.currentGameResponsesRef);
      }
      base.removeBinding(this.allowMultipleVotesRef);
      base.removeBinding(this.numberOfVotesRef);
      base.removeBinding(this.sessionLengthRef);
      base.removeBinding(this.voteSessionRef);
      base.removeBinding(this.endVideoLinkRef);
      base.removeBinding(this.formQuestionsRef);
    }

    logout(){
      this.props.appStorage.removeItem('verifiedAge');
      this.props.appStorage.removeItem('userEmail');
      this.props.appStorage.removeItem('birthday');
      this.props.appStorage.removeItem('locationPermissions');
      this.setState({
        userEmail:false
      })
    }

    changeMilesToMeters(milesToConvert){
      return milesToConvert*1609.344;
    }

    getLocation(){
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject("Geolocation is not supported by your browser. Please change browsers to play!");
        } else {
          const toCheckLatitude = this.props.variables.latitude || 51.525;
          const toCheckLongitude = this.props.variables.longitude || 7.4575;
          navigator.geolocation.getCurrentPosition(
              function(position) {
                resolve(getDistance({latitude: position.coords.latitude, longitude: position.coords.longitude}, {
                  latitude: toCheckLatitude,
                  longitude: toCheckLongitude,
                }))
              },
              (err) => {
                if(err.message === "User denied Geolocation"){
                  reject("Position could not be determined because the browser does not have permission.  Please go to your browsers settings to allow it access to your location");
                } else {
                  console.log(err.message);
                  reject("An unknown error occurred, check your internet connection and try again");
                }
              }
          );
        }
      })
    }

    getLocationPermission(){
      const locationErrorTitle = "Location Error";
      this.getLocation().then(distance_meters => {
        this.props.appStorage.setItem('locationPermissions', "true");
        const allowed_distance = this.changeMilesToMeters(this.props.variables.acceptableDistance || 100); //In miles
        if(distance_meters <= allowed_distance){
          this.setState({
            modal:false,
            loading:false,
            locationChecking: false
          });
        } else {
          this.setState({
            modal:false,
            loading:false
          });
          confirmAlert({
            title: locationErrorTitle,
            variables: this.props.variables,
            message: "Too far from game area to participate!",
            buttons: [
              {
                label: 'Retry',
                onClick: () => {
                  this.checkUsersLocation()
                }
              }
            ]
          });
        }
      }, error => {
        console.log(error);
        this.setState({
          modal:false,
          loading:false
        });
        this.props.appStorage.setItem('locationPermissions', "false");
        if(typeof error != "string"){
          error = error.message
        }
        confirmAlert({
          title: locationErrorTitle,
          variables: this.props.variables,
          message: error,
          buttons: [
            {
              label: 'Retry',
              onClick: () => {
                this.checkUsersLocation()
              }
            }
          ]
        });
      })
    }

    checkUsersLocation(){
      const variables = this.props.variables || {};
      const locationPermissions = this.props.appStorage.getItem('locationPermissions');
      if(!variables.collectDistance) {
        this.setState({locationChecking: false})
      } else if(locationPermissions === "false" || !locationPermissions){
        const locationPermissionsHeader = variables.locationPermissionsHeader || "Location Permissions Required";
        const locationPermissionsBody = variables.locationPermissionsBody || "We need your location in order to play! We use this information to make your experience better";
        confirmAlert({
          title: locationPermissionsHeader,
          variables: variables,
          message: locationPermissionsBody,
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                this.setState({
                  loading: true,
                });
                this.getLocationPermission()
              }
            }
          ],
        })
      } else {
        this.setState({
          loading: true,
        });
        this.getLocationPermission()
      }
    }

    updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    toggle() {
      this.setState({modal: !this.state.modal});
    }

    onEnded(){
      const tenantVariables = this.props.variables || {};
      const stringConstants = this.props.stringConstants || {};
      if(this.state.modalVideo){
        this.setState({
          modalVideo: false
        }, () => {
          confirmAlert({
            title: tenantVariables.thanksForVotingHeader || "Thanks For Voting!",
            variables: tenantVariables,
            message: tenantVariables.thanksForVotingMessage,
            buttons: [
              {
                label: stringConstants.OKTEXT,
              }
            ]
          });
        })
      } else {
        this.setState({
          modal:false
        })
      }
    }

    logUserActivity(currentGame){
      const vm = this;
      let userEmailToBase64 = "";
      if(currentGame && this.state.userEmail.indexOf('@') > -1){
        let gameid = currentGame;
        userEmailToBase64 = btoa(this.state.userEmail);
        base.post('userGameHistory/'+userEmailToBase64+`/${gameid}` , {
          data:gameid,
          then(err){
            if(!err){
              vm.setState({
                alreadyUpdate: gameid,
              })
              console.log("user game logged!")
            }
          }
        })
      }
      var userID = this.state.userEmail;
      if(userID.indexOf('@') > -1){
        userID = btoa(userID);
      }
      if(currentGame){
        base.post('currentGameVisitors/'+userID+"/", {
          data:userID,
          then(err){
            if(!err){
              console.log("currentVisitorLogged!")
            }
          }
        })
      }
    }

    collectNumberOfAnswersPerQuestion(responses, low_time=null){
      const userAnswersObject = {};
      for(const i in responses){
        const response = responses[i];
        if(low_time && response.timeStamp <= low_time){
          continue;
        }
        if(!userAnswersObject[response.questionId]){
          userAnswersObject[response.questionId] = response;
          userAnswersObject[response.questionId]["count"] = 1;
        } else {
          userAnswersObject[response.questionId]["count"]++;
        }
      }
      return userAnswersObject;
    }

    onClickAnswer(answerClicked, position, question){
      const {variables, stringConstants} = this.props;
      let {allowMultipleVotes, numberOfVotes, sessionLength, voteSession, currentGameResponses=[], questionAnswersInLimbo={}, userEmail, questionAnswered} = this.state;
      const gridItems = document.getElementsByClassName("grid-item");
      const element = gridItems[position];
      const questionId = question.id || question.key;
      let answerInfo = {};
      answerInfo['id'] = appDatabasePrimaryFunctions.ref().push().key;
      answerInfo['answerText'] = answerClicked.answerText;
      answerInfo['position'] = position;
      answerInfo['answerId'] = answerClicked.id;
      answerInfo['questionId'] = questionId;
      answerInfo['uid'] = userEmail.indexOf('@') > -1 ? btoa(userEmail) : userEmail;
      if(questionAnswered){
        confirmAlert({
            title: stringConstants.POLLINGOVERHEADER,
            variables: variables,
            message: stringConstants.NOMOREVOTESATTHISTIMETEXT,
            buttons: [
              {
                label: stringConstants.OKTEXT,
              }
            ]
          });
        return;
      }
      let votesWithinTimeFrame = 0;
      let userAnswersObject;
      let low_time;
      const timeBoundResponses = voteSession && sessionLength;
      if(timeBoundResponses) {
        low_time = new Date().getTime() - sessionLength;
      }
      userAnswersObject = this.collectNumberOfAnswersPerQuestion(currentGameResponses, low_time);
      let totalVotesCount = 0;
      for(const i in userAnswersObject){
        const objectWithVotes = userAnswersObject[i];
        totalVotesCount = totalVotesCount + objectWithVotes.count;
      }
      if(userAnswersObject[questionId]){
        votesWithinTimeFrame = userAnswersObject[questionId].count || 0;
      } else {
        votesWithinTimeFrame = 0;
      }
      votesWithinTimeFrame+= (questionAnswersInLimbo[questionId] ? questionAnswersInLimbo[questionId].length : 0);
      if (((!allowMultipleVotes && votesWithinTimeFrame > 0) || (allowMultipleVotes && numberOfVotes && numberOfVotes !== 0 && votesWithinTimeFrame >= parseInt(numberOfVotes))) && !questionAnswersInLimbo[questionId]) {
        let message = '';
        if (!allowMultipleVotes && votesWithinTimeFrame > 0) {
          message = stringConstants.ONLYONEPICKPERFAN;
        } else if (allowMultipleVotes && numberOfVotes && numberOfVotes !== 0 && votesWithinTimeFrame >= parseInt(numberOfVotes)) {
          message = stringConstants.ONLYCERTAINNUMBEROFVOTESTEXTFIRST + " " + numberOfVotes + " " + stringConstants.ONLYCERTAINNUMBEROFVOTESTEXTSECOND;
        }
        if (message !== '') {
          confirmAlert({
            title: variables.noMoreVotesAllowedHeader || stringConstants.NOMOREPICKSTEXT,
            variables: variables,
            message: variables.noMoreVotesAllowedMessage || message,
            buttons: [
              {
                label: stringConstants.OKTEXT,
              }
            ]
          });
          return;
        }
      } else if(((!allowMultipleVotes && votesWithinTimeFrame > 0) || (allowMultipleVotes && numberOfVotes && numberOfVotes !== 0 && votesWithinTimeFrame >= parseInt(numberOfVotes))) && questionAnswersInLimbo[questionId].length > 0){
        questionAnswersInLimbo[questionId] = [...questionAnswersInLimbo[questionId].slice(1), answerInfo];
      } else {
        if(!questionAnswersInLimbo[questionId]) questionAnswersInLimbo[questionId] = [];
        questionAnswersInLimbo[questionId].push(answerInfo);
      }
      this.setState({questionAnswersInLimbo})
      element.classList.add("sheen");
      element.classList.add('start-now');
      setTimeout(function () {
        element.classList.remove("sheen");
        element.classList.remove('start-now')
      }, 1000);
    }

    renderHoldingScreen(){
      const tenantVariables = this.props.variables || {};
      const frontLogoImage = tenantVariables.frontLogoImage || sampleAppFrontImage;
      const secondaryColor = tenantVariables.secondaryColor || "white";
      const primaryColor = tenantVariables.primaryColor || "black";
      return(
        <>
            <div className="hero-text-container">
              <img src={frontLogoImage} className="main-hero-image" alt=""/>
            </div>
            {tenantVariables.playingText &&
                <span className="emphasizedText" style={{backgroundColor:primaryColor, color:secondaryColor}}>
                  {tenantVariables.playingText}
                </span>
            }
        </>
        )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if((prevState.questionAnswered && !this.state.questionAnswered) || (prevState.alreadyUpdate !== this.state.alreadyUpdate) || (prevState.gameActive && !this.state.gameActive)){
        this.resetGame();
        this.removeReactAlert();
      }
    }

    resetGame(){
      this.setState({
        questionNumber: 0,
        questionAnswersInLimbo: {}
      })
    }

    async handleSubmit(event){
      event.preventDefault();
      const formQuestions = this.state.formQuestions || [];
      const stringConstants = this.props.stringConstants || {};
      const tenantVariables = this.props.variables || {};
      const dataObject = {};
      let somethingChecked = false;
      for(const i in formQuestions){
        let userResponse = false;
        if(this.refs[formQuestions[i].id].checked){
          somethingChecked = true;
          userResponse = true;
        }
        dataObject[formQuestions[i].id] = userResponse;
      }
      const other_checkbox = this.refs.other_checkbox.checked;
      const otherInput = this.state.otherInput.trim();
      if(other_checkbox){
        somethingChecked = true;
      }
      if(!somethingChecked) {
        confirmAlert({
          variables: tenantVariables,
          title: stringConstants.MISSINGINFOTEXT,
          message: "To submit you need to check at least one box",
          buttons: [
            {
              label: stringConstants.OKTEXT,
            }
          ]
        });
        return
      } else if(other_checkbox && !otherInput){
        confirmAlert({
          variables: tenantVariables,
          title: stringConstants.MISSINGINFOTEXT,
          message: "If you check other you need to fill in the other input",
          buttons: [
            {
              label: stringConstants.OKTEXT,
            }
          ]
        });
        return;
      }
      const base64EncodedEmail = btoa(this.state.userEmail);
      if(!base64EncodedEmail) return;

      try {
        await base.update(`users/${base64EncodedEmail}`, {
          data: {
            otherInput: otherInput || "",
            form_responses: dataObject
          }
        });

        document.getElementById('more-info-form').style.display = "none";

        confirmAlert({
          variables: tenantVariables,
          title: tenantVariables.thanksForSubmittingFormHeader || "Submitted Successfully!",
          message: tenantVariables.thanksForSubmittingFormBody || "",
          buttons: [{
            label: stringConstants.OKTEXT
          }]
        });
      } catch (err) {
        console.log(err);

        confirmAlert({
          variables: tenantVariables,
          title: stringConstants.ERRORTEXT,
          message: err.message,
          buttons: [
            {
              label: stringConstants.OKTEXT,
            }
          ]
        });
      }
    }

    async navigateButtonClick(direction, numberOfQuestions) {
      const {variables, stringConstants} = this.props;
      let {
        currentGameResponses = [],
        sessionLength,
        questionNumber = 0,
        questions,
        voteSession,
        questionAnswersInLimbo = {},
        numberOfVotes,
        allowMultipleVotes
      } = this.state;
      let low_time;
      const timeBoundResponses = voteSession && sessionLength;
      if (timeBoundResponses) {
        low_time = new Date().getTime() - sessionLength;
      }
      const userAnswersObject = this.collectNumberOfAnswersPerQuestion(currentGameResponses, low_time);
      let votesWithinTimeFrame = 0;
      const question = questions[questionNumber];
      const questionId = question.id || question.key;
      let totalVotesCount = 0;
      for (const i in userAnswersObject) {
        const objectWithVotes = userAnswersObject[i];
        totalVotesCount = totalVotesCount + objectWithVotes.count;
      }
      if (userAnswersObject[questionId]) {
        votesWithinTimeFrame = userAnswersObject[questionId].count || 0;
      } else {
        votesWithinTimeFrame = 0;
      }
      votesWithinTimeFrame += questionAnswersInLimbo[questionId] ? questionAnswersInLimbo[questionId].length : [];
      if (direction === "prev" && questionNumber > 0) {
        questionNumber--;
        this.setState({
          questionNumber,
          startAnimating: false
        }, () => {
          this.setState({
            startAnimating: true,
            modal: !!questions[questionNumber].videoLink
          })
        })
        return;
      }

      console.log(votesWithinTimeFrame, numberOfVotes)
      if(!allowMultipleVotes){
        numberOfVotes = 1;
      }
      if (votesWithinTimeFrame < parseInt(numberOfVotes) && !this.state.questionAnswered) {
          confirmAlert({
            title: variables.allAnswersNotFilledOutHeader || "Hold On!",
            variables: variables,
            message: variables.allAnswersNotFilledOutMessage || "Use all your votes before moving on",
            buttons: [
              {
                label: stringConstants.OKTEXT,
              }
            ]
          });
          return;
      }

      if(questionNumber < numberOfQuestions - 1) {
        questionNumber++;
        this.setState({
          questionNumber,
          startAnimating: false,
        }, () => {
          this.setState({
            startAnimating: true,
            modal: !!questions[questionNumber].videoLink
          })
        })
        return;
      }

      let totalQuestionsInLimboResponses = 0;
      for(const questionAnswersInLimboIndex in questionAnswersInLimbo){
        const questionAnswerArray = questionAnswersInLimbo[questionAnswersInLimboIndex] || [];
        totalQuestionsInLimboResponses+=questionAnswerArray.length
      }


      if(totalQuestionsInLimboResponses === 0 && totalVotesCount === numberOfVotes * questions.length){
        confirmAlert({
          title: variables.thanksForVotingHeader || "Thanks For Voting!",
          variables: variables,
          message: variables.thanksForVotingMessage,
          buttons: [
            {
              label: stringConstants.OKTEXT,
            }
          ]
        });
        return;
      }

      if(totalQuestionsInLimboResponses < numberOfVotes * questions.length){
        confirmAlert({
          title: variables.allAnswersNotFilledOutHeader || "Hold On!",
          variables: variables,
          message: variables.allAnswersNotFilledOutMessage || "Use all your votes before moving on",
          buttons: [
            {
              label: stringConstants.OKTEXT,
            }
          ]
        });
        return;
      }

      const response = await confirmAlertAsync({
        title: variables.confirmLockedInHeader || "Hold On!",
        variables: variables,
        message: variables.confirmLockedInMessage || "Are you sure you want to lock in your answers? You won't be able to change your answer afterwards",
        buttons: [
          {
            label: stringConstants.YESCONFIRMBUTTONTEXT,
            onClick: () => {
              return true;
            }
          },
          {
            label: stringConstants.NODISMISSBUTTONTEXT,
            onClick: () => {
              return false;
            }
          }
        ]
      });
      if(!response) return;

      const objectToSave = {};
      for (const i in questionAnswersInLimbo) {
        const questionToUploadArray = questionAnswersInLimbo[i];
        for(const t in questionToUploadArray){
          const answerInfo = questionToUploadArray[t];
          answerInfo['timeStamp'] = new Date().getTime();
          objectToSave[answerInfo.id] = answerInfo;
        }
      }
      try {
        await appDatabasePrimaryFunctions.ref('userAnswers').update(objectToSave);
      } catch (e) {
        confirmAlert({
          title: stringConstants.ERRORTEXT,
          variables: variables,
          message: stringConstants.UNKNOWNERROROCCURED,
          buttons: [
            {
              label: stringConstants.OKTEXT,
            }
          ]
        });
        return;
      }
      let actualNumberOfVotesAllowedSingleQuestionLimit = numberOfVotes;
      if(!allowMultipleVotes){
        actualNumberOfVotesAllowedSingleQuestionLimit = 1;
      }
      let actualNumberOfVotesAllowed = actualNumberOfVotesAllowedSingleQuestionLimit * numberOfQuestions;
      let totalCountOfQuestionsToSubmit = 0;
      for(const zT in questionAnswersInLimbo){
        totalCountOfQuestionsToSubmit+=questionAnswersInLimbo[zT].length;
      }
      let currentVotesToSubmitCount = totalVotesCount + totalCountOfQuestionsToSubmit;
      if(currentVotesToSubmitCount === actualNumberOfVotesAllowed){
        if(this.state.endPollingVideoLink){
          this.setState({modalVideo: true});
        } else {
          confirmAlert({
            title: variables.thanksForVotingHeader || "Thanks For Voting!",
            variables: variables,
            message: variables.thanksForVotingMessage,
            buttons: [
              {
                label: stringConstants.OKTEXT,
              }
            ]
          });
        }
      }
      this.setState({questionAnswersInLimbo: {}});
    }

    renderPlayingScreen(){
      const {variables={}, stringConstants={}} = this.props;
      let {currentGameResponses=[], userAnswers=[], questionNumber=0, questions, answerList, firstStartVideo, questionAnswered, questionAnswersInLimbo={}, voteSession, sessionLength, numberOfVotes} = this.state;
      const savedAnswersLength = currentGameResponses.length;
      let {secondaryColor="#000", primaryColor="#fff", topLeftImage=sampleAppTopImage, showFanPercentages, showScoreboardPercentages} = variables;
      let videoURL = "";
      let totalTriviaAnswers = 0;
      let show_percentages = false;
      let question = {};
      let questionId;
      if (questions.length > 0 && questionNumber < questions.length) {
        question = questions[questionNumber];
        questionId = question.id || question.key;
        answerList = question.answers;
        videoURL = questions[questionNumber].videoLink;
        if(questionNumber === 0 && !firstStartVideo && videoURL){
          this.setState({modal: true, firstStartVideo: true})
        }
      }
      let low_time;
      let answersInTimePeriod = false;
      const timeBoundResponses = voteSession && sessionLength;
      if (timeBoundResponses) {
        low_time = new Date().getTime() - sessionLength;
      }
      const userAnswersObject = this.collectNumberOfAnswersPerQuestion(currentGameResponses, low_time);
      if(Object.keys(userAnswersObject).length > 0){
        answersInTimePeriod = true;
      }
      if(showFanPercentages === "all" || !showScoreboardPercentages){
        show_percentages = true
      } else if (showFanPercentages === "parttime" && (questionAnswered || answersInTimePeriod)) {
        show_percentages = true
      }
      if(question.showPhonePercentages && question.showPhonePercentages === "all"){
        show_percentages = true;
      } else if(question.showPhonePercentages && question.showPhonePercentages === "parttime" && (questionAnswered || answersInTimePeriod)){
        show_percentages = true;
      } else if(question.showPhonePercentages && question.showPhonePercentages === "never"){
        show_percentages = false;
      }
      let latestPicks = [];
      if(userAnswers.length > 0 || (questionAnswersInLimbo[questionId] && questionAnswersInLimbo[questionId].length > 0)){
        const tempCount = {};
        for(const answerIndex in userAnswers){
          const answerId = userAnswers[answerIndex].answerId;
          if(userAnswers[answerIndex].questionId === questionId){
            totalTriviaAnswers++;
            if(tempCount[answerId]){
              tempCount[answerId]['count'] = tempCount[answerId]['count'] + 1;
            } else {
              tempCount[answerId] = {};
              tempCount[answerId]['count'] = 1;
              tempCount[answerId]['answerText'] = userAnswers[answerIndex].answerText;
            }
          }
        }
        currentGameResponses = currentGameResponses.concat(questionAnswersInLimbo[questionId] || [])
        if(currentGameResponses.length > 0){
          for(const responseIndex in currentGameResponses){
            const response = currentGameResponses[responseIndex];
            if(response.questionId === questionId){
              // lastPickId = response.answerId;
              if(latestPicks.length === numberOfVotes){
                // Remove the oldest entry from the latestPicks
                latestPicks.shift();
              }
              // Add the new vote to the latestPicks
              latestPicks.push(response.answerId)
            }
          }
        }

        for(const add_answer in answerList){
          if(tempCount[answerList[add_answer].id]){
            answerList[add_answer]['count'] = tempCount[answerList[add_answer].id].count
          } else {
            answerList[add_answer]['count'] = 0
          }
        }
      }

      if (typeof videoURL === "object") videoURL = "";
      return(
          <>
            <div className="container-fluid" style={{marginBottom: 200}}>
              <div className="creator-awards-logo-playscreen user">
                <img src={question.topLeftImage || topLeftImage} alt="" style={{marginBottom:"0"}}/>
              </div>
              {this.state.startAnimating &&
                  <PoseGroup animateOnMount={true} delta={1} style={{margin: "auto", width: "100%"}}>
                    <Trans key={233}>
                      <div className="top-text" style={{justifyContent: "center", maxWidth: 800}}>
                        {this.state.questionAnswered &&
                            <p className="top-text-header" style={{fontWeight: 700, color: variables.userQuestionColor}}>{stringConstants.FINALRESULTTEXT}</p>
                        }
                        <p className="top-text-mobile" style={{wordWrap: "break-word", fontWeight: 700, color: variables.userQuestionColor, marginBottom: question.questionDescription && 0 }}>{question.questionText}</p>
                        <span style={{fontSize: 18, color: variables.userQuestionColor}}>{question.questionDescription}</span>
                      </div>
                      <div className="row">
                        <AnswerItemsComponent latestPicks={latestPicks} show_percentages={show_percentages} gameover={this.state.questionAnswered} totalCount={totalTriviaAnswers} question={question} answers={answerList} tenantVariables={variables} onClickAnswer={(item, i) => {
                          this.onClickAnswer(item, i, question)
                        }}/>
                      </div>
                    </Trans>
                  </PoseGroup>
              }
              <div className="container-out" id="more-info-form" style={{marginTop: 10, display: variables.formHeaderText && savedAnswersLength > 0 ? 'block' : 'none'}}>
                <div className="question-box question-form" style={{padding: '15px'}}>
                  <h4 style={{fontFamily: "Oswald", fontWeight: 700, color: "black"}}>{variables.formHeaderText}</h4>
                  <form onSubmit={this.handleSubmit} id="user-values-form">
                    <div style={{color:"black", textAlign: "left"}}>
                      {
                        this.state.formQuestions.map(function(item, i){
                          return <div className="checkbox" style={{padding: '5px'}} key={i}>
                            <label className="want_emails"><input type="checkbox" ref={item.id}/> {item.text}</label>
                          </div>
                        })
                      }
                      {/*Other Response needs to be displayed to hide because of ref that will BREAK if you hide using react */}
                      <div style={{display: variables.otherResponse ? "block":"none"}}>
                        <div className="checkbox" style={{padding: '5px'}}>
                          <label className="want_emails">
                            <input type="checkbox" ref="other_checkbox" onClick={()=> this.setState({otherCheck: !this.state.otherCheck})}/> {stringConstants.OTHERTEXT}
                          </label>
                        </div>
                        {this.state.otherCheck &&
                            <div className="input-group">
                              <input id="otherInput" name="otherInput" type="text" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder={stringConstants.OTHERTEXTPLACEHOLDER}/>
                            </div>
                        }
                      </div>
                    </div>
                    <button style={{backgroundColor: primaryColor, color: secondaryColor}} className="btn btn-play" id="submitButton"><strong>{stringConstants.SUBMITBUTTONTEXT}</strong></button>
                  </form>
                </div>
              </div>
              {questions && questions.length > 0 &&
                  <div className="bottom_row_fixed" style={{backgroundColor: "black"}}>
                    <button onClick={()=>this.navigateButtonClick("prev", questions.length)} className="btn btn-info" style={{backgroundColor: primaryColor, color: secondaryColor, visibility: questionNumber === 0 ? "hidden": "", float: "left", height:90, width:90, fontSize: "1.8em", margin:5, border: "none", fontWeight: 800}}>Prev</button>
                    {(questionNumber + 1 < questions.length || (!this.state.questionAnswered && !answersInTimePeriod)) &&
                        <button onClick={()=>this.navigateButtonClick("next", questions.length)} className="btn btn-info" style={{backgroundColor: primaryColor, color: secondaryColor, float: "right", height:90, width:90, fontSize: "1.8em", margin: 5, border: "none", fontWeight: 800}}>{questionNumber + 1 >= questions.length ? "Done": "Next"}</button>
                    }
                  </div>
              }
              <div className="mobilehide" style={{height:"100px", width:"1px"}}/>
            </div>
            <Modal isOpen={(this.state.modal && videoURL)} style={{width: '90%'}} id="myModal" toggle={this.toggle} contentClassName="transparentBackground">
              <ReactPlayer config={{file: {attributes: {controlsList: 'nodownload', disablePictureInPicture: true}}}}
                           controls={true} pip={false} playing={this.state.modal} url={videoURL} playsinline={true}
                           muted={true} volume={0} onEnded={this.onEnded} width="100%" height="auto"/>
            </Modal>
          </>
        )
    }

    render() {
      const tenantVariables = this.props.variables || {};
      const tenantRules = this.state.tenantRules || {};
      const logOutButtonColor = tenantVariables.logOutButtonColor || "white";
      const turnOffLoginButton = ["bearslivepoll", 'seahawkspoll'].indexOf(process.env.REACT_APP_FIREBASE_PROJECT_ID) !== -1;
      const primaryColor = tenantVariables.primaryColor || "black";
      const secondaryColor = tenantVariables.secondaryColor || "white";
      const rulesInAppButtonText = tenantRules.rulesInAppButtonText || "Rules & Regs";
      let rulesShowInAppPopUpHeader = tenantRules.rulesShowInAppPopUpHeader;
      let rulesShowInAppPopUpText = tenantRules.rulesShowInAppPopUpText;
      let rulesPopUpText = tenantRules.rulesPopUpText;
      let rulesPopUpHeader = tenantRules.rulesPopUpHeader;
      const supportHeader = tenantRules.supportHeader || "NEED SUPPORT?";
      const supportText = tenantRules.supportText || "Email customerservice@website.mlb.com with your issue and we'll be in touch!";
      const link = tenantRules.rulesAndRegsLink;
      const isMlbApp =  process.env.REACT_APP_IS_MLB_TEAM === "true";
      const rulesShowInApp = tenantRules.rulesShowInApp || isMlbApp || false;
      if(rulesShowInApp) {
        if(!rulesShowInAppPopUpText && rulesPopUpText){
          rulesShowInAppPopUpText = rulesPopUpText;
        }
        if(!rulesShowInAppPopUpHeader && rulesPopUpHeader){
          rulesShowInAppPopUpHeader = rulesPopUpHeader;
        }
      }
      if(!this.state.userEmail){
        let redirectString = "/login";
        let langague = "";
        let splitWindowLocation = window.location.pathname.split('/') || "";
        if(window.location.pathname.split('/').length > 1){
          langague = "/" + splitWindowLocation[1]
          redirectString += langague
        }
        return (
            <Redirect to={redirectString} />
        )
      } else if(!tenantVariables.doNotCollectEmail && !validateEmail(this.state.userEmail)){
        this.logout();
      } else if(tenantVariables.doNotCollectEmail && validateEmail(this.state.userEmail)){
        this.logout();
      }
      const verifiedAge = this.props.checkForAgeGate(tenantVariables);
      if(!verifiedAge){
        let urlToGo = "/age_gate";
        let langauge = "/";
        let splitWindowLocation = window.location.pathname.split('/') || "";
        if(splitWindowLocation.length > 1){
          langauge += splitWindowLocation[1];
          urlToGo += langauge
        }
        return (
            <Redirect to={urlToGo} />
        )
      }
      let renderMainScreen = this.renderHoldingScreen();
      if(this.state.gameActive && !this.state.locationChecking){
        renderMainScreen = this.renderPlayingScreen();
      }
      let maxWidthAllowed = 300;
      const bodyWidth = Math.max(document.body.offsetWidth, document.body.clientWidth, document.body.scrollWidth);
      if(bodyWidth > 0 && bodyWidth < 300){
        maxWidthAllowed = bodyWidth;
      }
      const backgroundImage = tenantVariables.backgroundImage || appBackgroundImage;
      return(
          <div className="flex-container-home" style={{backgroundImage: "url(" + backgroundImage + ")"}}>
            <div className="flex-content-container-home">
              <div className="intro-container-home" style={{margin: "auto"}}>
                <div className="grid-wrapper">
                  <div className="flex-header-home" style={{marginTop:10}}>
                    <div style={{display: isMlbApp? "block":"none", textAlign: "left"}}>
                      <button className="btn btn-logout" onClick={() => { this.toggleSupport() }} style={{color: logOutButtonColor, borderColor: logOutButtonColor}}>Support</button>
                    </div>
                    <div style={{visibility: rulesShowInApp? "visible":"hidden", marginLeft: isMlbApp && "auto"}}>
                      <button className="btn btn-logout" onClick={() => { rulesShowInAppPopUpText?this.toggleRules():window.open(link, '_blank') }} style={{color: logOutButtonColor, borderColor: logOutButtonColor}}>{rulesInAppButtonText}</button>
                    </div>
                    <div style={{display: (isMlbApp || this.props.passedEmail || turnOffLoginButton) && "none"}}>
                      <button className="btn btn-logout" onClick={() => { this.logout() }} style={{color: logOutButtonColor, borderColor: logOutButtonColor}}>LOG OUT</button>
                    </div>
                  </div>
                  {renderMainScreen}
                </div>
              </div>
            </div>
            <Modal isOpen={this.state.winnerModal} id="myOtherModal">
              <center style={{maxWidth:maxWidthAllowed, marginTop:10, marginBottom: 10}}>
                <span className="unselectable">Hold your finger on the box to save this coupon to your photos<br/>👇👇👇👇👇👇</span>
                <div className="unselectable" style={{height:10, width: "100%"}}/>
                <center id="downloadModalId"/>
              </center>
            </Modal>
            <Modal isOpen={this.state.modalRules} style={{width: '90%'}} id="rulesModal">
              <ModalHeader style={{color: secondaryColor, padding:10}}>
                    <span style={{fontSize:25}}>
                        {rulesShowInAppPopUpHeader}
                    </span>
              </ModalHeader>
              <ModalBody>
                <center className="container-out">
                  <div className="question-box question-form">
                    <p style={{width:"100%",height:200, overflow:"scroll",padding:10, borderBottom:"1px solid black", borderTop: "1px solid black", fontWeight:100, fontSize:14}} dangerouslySetInnerHTML={{ __html:rulesShowInAppPopUpText}}/>
                    <button className="btn btn-default btn-admin btn-cancel" onClick={() => { this.toggleRules(); }} style={{color: secondaryColor, backgroundColor: primaryColor, fontWeight: '700', marginTop:'20px', fontSize:'1.3 rem'}}>Dismiss</button>
                  </div>
                </center>
              </ModalBody>
            </Modal>
            <Modal isOpen={this.state.modalSupport} style={{width: '90%'}} id="rulesModal">
              <ModalHeader style={{color: secondaryColor, padding:10}}>
                    <span style={{fontSize:25}}>
                        {supportHeader}
                    </span>
              </ModalHeader>
              <ModalBody>
                <center className="container-out">
                  <div className="question-box question-form">
                    <p style={{width:"100%",overflow:"scroll",fontWeight:100, fontSize:14, marginBottom: 0}} dangerouslySetInnerHTML={{ __html:supportText}}/>
                    <button className="btn btn-default btn-admin btn-cancel" onClick={() => { this.toggleSupport(); }} style={{color: secondaryColor, backgroundColor: primaryColor, fontWeight: '700', fontSize:'1.3 rem'}}>Dismiss</button>
                  </div>
                </center>
              </ModalBody>
            </Modal>
            <Modal isOpen={this.state.modalVideo} style={{width: '90%'}} id="myModalVideo" contentClassName="transparentBackground">
              <ReactPlayer config={{file: {attributes: {controlsList: 'nodownload', disablePictureInPicture: true}}}}
                           controls={true} pip={false} playing={this.state.modalVideo} url={this.state.endPollingVideoLink} playsinline={true}
                           muted={true} volume={0} onEnded={this.onEnded} width="100%" height="auto"/>
            </Modal>
          </div>
      )
    }
}

export default Main_App;
